<div
  #container
  class="image-positioner__frame"
  [style.aspect-ratio]="aspectRatio"
  (mousedown)="onMouseDown($event)"
  (touchstart)="onTouchStart($event)"
>
  <img
    class="image-positioner__img"
    [src]="imageSrc"
    [style.object-position]="objectPosition"
    draggable="false"
    alt=""
  />
  <div class="image-positioner__marker" [style.left.%]="currentX" [style.top.%]="currentY">
    <div class="image-positioner__marker-inner"></div>
  </div>
  <div class="image-positioner__hint">{{ 'shared.imagePositioner.dragHint' | transloco }}</div>
</div>